// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/foundations/icons/arrow-right-green.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: inline-block;
    font-family: var(--font-family);
}

a {
    cursor: pointer;
    color: var(--accent-strong-default);
    display: inline-block;
    font-family: var(--p2-regular-underlined-font-family);
    font-size: var(--p2-regular-underlined-font-size);
    letter-spacing: var(--p2-regular-underlined-letter-spacing);
    line-height: var(--p2-regular-underlined-line-height);
    font-weight: var(--p2-regular-underlined-font-weight);
    text-decoration: none;
}
a:hover {
    color: var(--accent-strong-hover);
}

.arrow {
    display: inline-block;
    border-bottom: 2px solid var(--accent-strong-default);
    border-right: 2px solid var(--accent-strong-default);
    height: var(--spacing-10);
    position: relative;
    bottom: -7px;
    margin-left: var(--spacing-10);
    transform: translate(0, -65%) rotate(-45deg);
    width: var(--spacing-10);
}

:host([kind="subtle"]) a,
:host([kind="subtle-underline"]) a {
    color: var(--text-default);
}
:host([kind="subtle-underline"]) a {
    text-decoration: underline;
}
:host([kind="subtle"]) .arrow,
:host([kind="subtle-underline"]) .arrow {
    border-color: var(--text-default);
}
:host([kind="ondark"]) a {
    color: var(--text-ondark);
}
:host([size="lg"]) a {
    font-family: var(--p1-regular-font-family);
    font-size: var(--p1-regular-font-size);
    letter-spacing: var(--p1-regular-letter-spacing);
    line-height: var(--p1-regular-line-height);
    font-weight: var(--p1-regular-font-weight);
}
:host([size="lg"]) .arrow {
    height: var(--spacing-15);
    width: var(--spacing-15);
    bottom: -9px;
}
:host([position="left"]) a {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
}
:host([position="left"]) .arrow {
    transform: translate(0, -65%) rotate(135deg);
    margin-left: var(--spacing-05);
    margin-right: var(--spacing-10);
}




.animated-arrow {
    position: relative;
    display: inline-block;
    /*-webkit-transition: -webkit-transform .3s ease;*/
    /*transition: -webkit-transform .3s ease;*/
    transition: transform .3s ease;
    width: 10px;
    pointer-events: none;
}
/*arrow*/
.animated-arrow::after {
    position: absolute;
    top: -10px;
    right: 0;
    left: auto;
    content: '';
    display: inline-block;
    width: 7px;
    height: 11px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: 7px 11px;
    transform: translateX(5px);
    transition: transform .3s ease;
}
a:hover .animated-arrow::after {
    transform: translateX(15px);
}

/*line */
.animated-arrow::before {
    background: #333d3e;
    content: "";
    position: absolute;
    top: -5px;
    right: -4px;
    /*-webkit-transition: all .3s ease;*/
    transition: all .3s ease;
    height: 1px;
    width: 0;
}
a:hover .animated-arrow::before {
    content: "";
    height: 1px;
    background: var(--accent-strong-default);
    position: absolute;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    width: 1em;
    transform: translateX(10px);
}


@media (max-width: 940px) {
    :host([visibility="desktop"]) {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/link/style/index.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,qBAAqB;IACrB,qDAAqD;IACrD,iDAAiD;IACjD,2DAA2D;IAC3D,qDAAqD;IACrD,qDAAqD;IACrD,qBAAqB;AACzB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,qDAAqD;IACrD,oDAAoD;IACpD,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,4CAA4C;IAC5C,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,gDAAgD;IAChD,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,4CAA4C;IAC5C,8BAA8B;IAC9B,+BAA+B;AACnC;;;;;AAKA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kDAAkD;IAClD,0CAA0C;IAC1C,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;AACxB;AACA,QAAQ;AACR;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,2EAAsF;IACtF,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;;AAEA,QAAQ;AACR;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,wBAAwB;IACxB,WAAW;IACX,QAAQ;AACZ;AACA;IACI,WAAW;IACX,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,UAAU;IACV,2BAA2B;AAC/B;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[":host {\n    display: inline-block;\n    font-family: var(--font-family);\n}\n\na {\n    cursor: pointer;\n    color: var(--accent-strong-default);\n    display: inline-block;\n    font-family: var(--p2-regular-underlined-font-family);\n    font-size: var(--p2-regular-underlined-font-size);\n    letter-spacing: var(--p2-regular-underlined-letter-spacing);\n    line-height: var(--p2-regular-underlined-line-height);\n    font-weight: var(--p2-regular-underlined-font-weight);\n    text-decoration: none;\n}\na:hover {\n    color: var(--accent-strong-hover);\n}\n\n.arrow {\n    display: inline-block;\n    border-bottom: 2px solid var(--accent-strong-default);\n    border-right: 2px solid var(--accent-strong-default);\n    height: var(--spacing-10);\n    position: relative;\n    bottom: -7px;\n    margin-left: var(--spacing-10);\n    transform: translate(0, -65%) rotate(-45deg);\n    width: var(--spacing-10);\n}\n\n:host([kind=\"subtle\"]) a,\n:host([kind=\"subtle-underline\"]) a {\n    color: var(--text-default);\n}\n:host([kind=\"subtle-underline\"]) a {\n    text-decoration: underline;\n}\n:host([kind=\"subtle\"]) .arrow,\n:host([kind=\"subtle-underline\"]) .arrow {\n    border-color: var(--text-default);\n}\n:host([kind=\"ondark\"]) a {\n    color: var(--text-ondark);\n}\n:host([size=\"lg\"]) a {\n    font-family: var(--p1-regular-font-family);\n    font-size: var(--p1-regular-font-size);\n    letter-spacing: var(--p1-regular-letter-spacing);\n    line-height: var(--p1-regular-line-height);\n    font-weight: var(--p1-regular-font-weight);\n}\n:host([size=\"lg\"]) .arrow {\n    height: var(--spacing-15);\n    width: var(--spacing-15);\n    bottom: -9px;\n}\n:host([position=\"left\"]) a {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n}\n:host([position=\"left\"]) .arrow {\n    transform: translate(0, -65%) rotate(135deg);\n    margin-left: var(--spacing-05);\n    margin-right: var(--spacing-10);\n}\n\n\n\n\n.animated-arrow {\n    position: relative;\n    display: inline-block;\n    /*-webkit-transition: -webkit-transform .3s ease;*/\n    /*transition: -webkit-transform .3s ease;*/\n    transition: transform .3s ease;\n    width: 10px;\n    pointer-events: none;\n}\n/*arrow*/\n.animated-arrow::after {\n    position: absolute;\n    top: -10px;\n    right: 0;\n    left: auto;\n    content: '';\n    display: inline-block;\n    width: 7px;\n    height: 11px;\n    background: url(\"src/foundations/icons/arrow-right-green.svg\") no-repeat center center;\n    background-size: 7px 11px;\n    transform: translateX(5px);\n    transition: transform .3s ease;\n}\na:hover .animated-arrow::after {\n    transform: translateX(15px);\n}\n\n/*line */\n.animated-arrow::before {\n    background: #333d3e;\n    content: \"\";\n    position: absolute;\n    top: -5px;\n    right: -4px;\n    /*-webkit-transition: all .3s ease;*/\n    transition: all .3s ease;\n    height: 1px;\n    width: 0;\n}\na:hover .animated-arrow::before {\n    content: \"\";\n    height: 1px;\n    background: var(--accent-strong-default);\n    position: absolute;\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n    width: 1em;\n    transform: translateX(10px);\n}\n\n\n@media (max-width: 940px) {\n    :host([visibility=\"desktop\"]) {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
